import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CalculatorIcon, HistoryIcon, LogOutIcon } from 'lucide-react';
import { LeasingCalculator } from './components/LeasingCalculator';
import { HistoryView } from './components/HistoryView';
import { LoginPage } from './components/LoginPage';
import { useCalculatorHistory } from './hooks/useCalculatorHistory';
import { TermMonths } from './utils/leasingFactors';
type Tab = 'calculator' | 'history';
export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState<'admin' | 'basic'>('admin');
  const [activeTab, setActiveTab] = useState<Tab>('calculator');
  const {
    history,
    addEntry,
    removeEntry,
    clearHistory
  } = useCalculatorHistory();
  if (!isAuthenticated) {
    return <LoginPage onLogin={role => {
      setUserRole(role);
      setIsAuthenticated(true);
    }} data-id="element-0" />;
  }
  const handleSaveCalculation = (naw: number, term: TermMonths, monthlyRate: number, factor: number) => {
    addEntry(naw, term, monthlyRate, factor);
  };
  const tabs = [{
    id: 'calculator' as Tab,
    label: 'Kalkulator',
    icon: CalculatorIcon
  }, {
    id: 'history' as Tab,
    label: 'Historie',
    icon: HistoryIcon,
    badge: history.length
  }];
  return <div className="min-h-screen w-full bg-stone-100" data-id="element-1">
      {/* Header */}
      <header className="bg-white border-b border-stone-200" data-id="element-2">
        <div className="max-w-2xl mx-auto px-4 py-6" data-id="element-3">
          <div className="flex items-center justify-between" data-id="element-4">
            <div className="flex items-center gap-3" data-id="element-5">
              <img src="https://cdn.magicpatterns.com/uploads/n2ZtD8CsZ6GJoFZZcw3BxP/IMG_3249.jpg" alt="PEZULA" className="w-10 h-10 rounded-xl object-cover" data-id="element-6" />
              <div data-id="element-7">
                <h1 className="text-xl font-bold text-stone-900 tracking-tight" data-id="element-8">
                  PEZULA
                </h1>
                <p className="text-xs text-stone-500 font-medium" data-id="element-9">
                  Leasingkalkulator
                </p>
              </div>
            </div>
            <button onClick={() => setIsAuthenticated(false)} className="flex items-center gap-1.5 px-3 py-1.5 text-sm text-stone-500 hover:text-stone-700 hover:bg-stone-100 rounded-lg transition-colors" aria-label="Abmelden" data-id="element-10">
              <LogOutIcon className="w-4 h-4" data-id="element-11" />
              <span className="hidden sm:inline" data-id="element-12">Abmelden</span>
            </button>
          </div>
        </div>
      </header>

      {/* Tab Navigation */}
      <nav className="bg-white border-b border-stone-200 sticky top-0 z-10" data-id="element-13">
        <div className="max-w-2xl mx-auto px-4" data-id="element-14">
          <div className="flex relative" data-id="element-15">
            {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex items-center gap-2 px-5 py-3.5 text-sm font-medium transition-colors relative ${activeTab === tab.id ? 'text-stone-900' : 'text-stone-500 hover:text-stone-700'}`} aria-selected={activeTab === tab.id} role="tab" data-id="element-16">
                <tab.icon className="w-4 h-4" data-id="element-17" />
                {tab.label}
                {tab.badge !== undefined && tab.badge > 0 && <span className="ml-1 px-1.5 py-0.5 text-xs font-semibold bg-stone-200 text-stone-700 rounded-full" data-id="element-18">
                    {tab.badge}
                  </span>}
                {activeTab === tab.id && <motion.div layoutId="tab-indicator" className="absolute bottom-0 left-0 right-0 h-0.5 bg-stone-700" transition={{
              type: 'spring',
              stiffness: 500,
              damping: 30
            }} data-id="element-19" />}
              </button>)}
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="max-w-2xl mx-auto px-4 py-6" data-id="element-20">
        {activeTab === 'calculator' ? <LeasingCalculator onSaveCalculation={handleSaveCalculation} userRole={userRole} data-id="element-21" /> : <HistoryView history={history} onRemoveEntry={removeEntry} onClearHistory={clearHistory} data-id="element-22" />}
      </main>

      {/* Footer */}
      <footer className="max-w-2xl mx-auto px-4 py-8 text-center" data-id="element-23">
        <p className="text-xs text-stone-400" data-id="element-24">
          Alle Berechnungen sind unverbindlich. Für verbindliche Angebote
          kontaktieren Sie bitte Ihren PEZULA-Ansprechpartner.
        </p>
      </footer>
    </div>;
}